import { render, staticRenderFns } from "./DialogCadastroMedicamento.vue?vue&type=template&id=7d2f0fbc&scoped=true&"
import script from "./DialogCadastroMedicamento.vue?vue&type=script&lang=js&"
export * from "./DialogCadastroMedicamento.vue?vue&type=script&lang=js&"
import style0 from "./DialogCadastroMedicamento.vue?vue&type=style&index=0&id=7d2f0fbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2f0fbc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VFlex,VForm,VLayout})
